import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClipboardClock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M16 14v2.2l1.6 1" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 4h2a2 2 0 0 1 2 2v.832" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 6
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 2,
			width: 8,
			height: 4,
			rx: 1
		})
	]
});
const ForwardRef = forwardRef(SvgClipboardClock);
export default ForwardRef;
